var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _circle3, _path, _path2, _circle4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrowMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "22 30 168 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 176,
    r: 46,
    fill: "none",
    stroke: "#1C1917",
    strokeWidth: 14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 176,
    r: 31,
    fill: "none",
    stroke: "#B4491C",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 148,
    width: 5,
    height: 22,
    rx: 2,
    fill: "#B4491C",
    transform: "rotate(0 114 176)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 148,
    width: 5,
    height: 22,
    rx: 2,
    fill: "#B4491C",
    transform: "rotate(72 114 176)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 148,
    width: 5,
    height: 22,
    rx: 2,
    fill: "#B4491C",
    transform: "rotate(144 114 176)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 148,
    width: 5,
    height: 22,
    rx: 2,
    fill: "#B4491C",
    transform: "rotate(216 114 176)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 148,
    width: 5,
    height: 22,
    rx: 2,
    fill: "#B4491C",
    transform: "rotate(288 114 176)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 176,
    r: 7,
    fill: "#B4491C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1917",
    d: "M185 72 C175 66 162 61 152 58 C147 47 136 41 123 43 C111 45 103 53 99 63 C87 70 71 84 61 98 L26 128 L34 136 L70 115 C88 119 112 117 126 105 C133 98 139 88 143 80 C145 76 148 74 152 73 L178 72 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153 66 L174 70",
    stroke: "#FAF7F3",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 54,
    r: 3,
    fill: "#FAF7F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 114 L102 125 M115 112 L117 125",
    stroke: "#1C1917",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrowMark);
export default __webpack_public_path__ + "static/media/crow-mark.84362f1e5340e2ae3ae96347fef126ec.svg";
export { ForwardRef as ReactComponent };